import React from 'react'

const Crosssign = ({ className }: { className?: string }) => {
    return (
        <svg className={className} data-icon="close" fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<rect fill="currentColor" height="24.5999" rx="1.64" transform="rotate(-45 3 5)" width="3.27999" x="3" y="5"></rect>
<rect fill="currentColor" height="24.5999" opacity="0.5" rx="1.64" transform="rotate(45 19.9998 3)" width="3.27999" x="19.9998" y="3"></rect>
</svg>
    )
}

export default Crosssign
